/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBodyWarning = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M11 9c.66 0 1.628.19 2.459.788a3.7 3.7 0 0 1 .373.31l-.998 1.997a1.58 1.58 0 0 0-.543-.684A1.977 1.977 0 0 0 12 11.24v2.525L9.882 18H8v4H6V11.354a2.65 2.65 0 0 0-.25.177c-.446.357-.75.84-.75 1.469v3H3v-3c0-1.372.696-2.388 1.5-3.031C5.272 9.35 6.237 9 7 9zm-3 7h2v-5H8zm13 6H10l5.5-11zm-6.1-1.65h1.2v-1.1h-1.2zM15 16h-.1v2.15h1.2v-2.2H15zM9 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
        clipRule="evenodd"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgBodyWarning as BodyWarning };
